// @ts-nocheck
/* Port of views/dashboard/module/IvrEditAclModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import { IVR_NODE_OPTION_DEFS, normalizeIvrNodeOptions } from '@/utilities/ivrAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaProjectDiagram,
} from '@/features/acl-settings/aclSettingsUi';

const IvrEditAclModal = ({
  show,
  onHide,
  initialOptions = [],
  onSave,
  optionDefs = IVR_NODE_OPTION_DEFS,
  limitedByParent = false,
}) => {
  const [selected, setSelected] = useState([]);
  const optionValues = optionDefs.map((o) => o.value);

  useEffect(() => {
    if (show) {
      const fromInitial = normalizeIvrNodeOptions(initialOptions).filter((v) => optionValues.includes(v));
      const defaults = optionDefs.filter((o) => o.defaultOn !== false).map((o) => o.value);
      setSelected(fromInitial.length > 0 ? fromInitial : defaults);
    }
  }, [show, initialOptions, optionDefs]);

  const toggle = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const handleReset = () => setSelected([]);

  const handleSave = () => {
    onSave(selected);
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="IVR — Node Options"
      icon={FaProjectDiagram}
      description="Select which IVR node types users with this ACL can add when creating or editing IVR flows. Answer and Hangup are always available."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={selected.length === 0 || optionDefs.length === 0}
    >
      <AclModalSection
        icon={FaProjectDiagram}
        title="IVR Node Types"
        subtitle="Choose node types users can add to IVR flows."
      >
        {optionDefs.length === 0 ? (
          <p className="acl-modal-empty">
            You do not have permission to grant any IVR node options.
          </p>
        ) : (
          optionDefs.map((opt) => (
            <AclModalOptionCheck
              key={opt.value}
              id={`ivr-node-${opt.value}`}
              label={opt.label}
              description={opt.description}
              checked={selected.includes(opt.value)}
              onChange={() => toggle(opt.value)}
            />
          ))
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default IvrEditAclModal;
